import BaseSwitch from 'components/atoms/base-switch';
import { useTranslation } from 'react-i18next';
import { useAssignPatient } from 'infrastructure/hooks/rpm/assign-tool/use-set-assign-patient';
import { useState, type FC } from 'react';
import ButtonLoadingIcon from 'components/atoms/icons/buttonLoadingIcon';
import useUser from 'utils/useUser';

import s from './styles.module.scss';

interface OptionCellProps {
  patientGuid: string;
}

const OptionCell: FC<OptionCellProps> = ({ patientGuid }) => {
  const { assignPatient, isLoading } = useAssignPatient();
  const [value, setValue] = useState(true);
  const { isMobileDevice } = useUser();

  const onChange = (v: boolean) => {
    setValue(v);
    assignPatient({
      patientGuid,
      action: 'unassign',
    });
  };

  const { t } = useTranslation();
  return (
    <div className={s['option-cell-wrapper']}>
      <p>{t('labels.unassign')}</p>
      {isLoading ? (
        <ButtonLoadingIcon className={s['spin-loading-icon']} />
      ) : (
        <BaseSwitch
          onChange={onChange}
          value={value}
          size={isMobileDevice ? 'small' : undefined}
        />
      )}
    </div>
  );
};
export default OptionCell;
